import { parseISO, startOfDay } from "date-fns";

import { AccountLifespan } from "./types";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const formatMonthLabel = (date: string): string => {
  const parsed = new Date(date);
  const month = parsed.toLocaleString("en-US", { month: "short" });
  const year = parsed.getFullYear().toString().slice(-2);
  return `${month} ${year}`;
};

// Local midnight, so a picker bound or a `Date`-valued form default compares by calendar day.
export const localToday = (now: Date = new Date()): Date =>
  new Date(now.getFullYear(), now.getMonth(), now.getDate());

export const isAfterLocalToday = (
  value: Date | string,
  now: Date = new Date(),
): boolean =>
  startOfDay(typeof value === "string" ? parseISO(value) : value).getTime() >
  localToday(now).getTime();

export const toIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Calendar arithmetic on the local-midnight frame, so a DST shift never moves the day.
export const addDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

export const durationOf = (
  { startDate, deactivationDate, isActive }: AccountLifespan,
  now: Date = new Date(),
): string => {
  const start = new Date(startDate);
  const end = !isActive && deactivationDate ? new Date(deactivationDate) : now;
  const days = Math.floor((end.getTime() - start.getTime()) / MS_PER_DAY);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);
  if (years > 0) {
    return `${years}y ${months % 12}m`;
  }
  if (months > 0) {
    return `${months}m`;
  }
  return `${days}d`;
};
